import { IInnerLayer } from '@lib/geo/map';
import { SnLiveUser } from '@lib/live-tracking/models';

import { IFsMap } from '../types';

export abstract class FsMapLiveUsersServiceProvider<
  TMap extends IFsMap = any,
  TComponentMarker = any,
> implements IInnerLayer
{
  // Abstract getters
  public abstract get isAvailable(): boolean;
  public abstract get userList(): SnLiveUser[];
  public abstract get countUsers(): number;
  public abstract get countActiveUser(): number;
  public abstract get selected(): SnLiveUser;

  // Abstract methods required by IInnerLayer
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;

  // Abstract core methods
  public abstract onMapLoaded(map: TMap): void;
  public abstract isSelected(id: string): boolean;
  public abstract select(id: string): void;
  public abstract deselect(): void;
  // Business logic methods removed - handled by LiveUsersService
  // public abstract teamIsActive(id: string): boolean;
  // public abstract toggleTeam(id: string): void;
  public abstract createUserMarker(user: SnLiveUser): TComponentMarker;
}
